export default function () {
  this.route("mod-community");
  this.route("creator-community");
  this.route("community-creator-resources", { path: "/creator/resources" });
  this.route("community-game", { path: "/games/:game_key" });
  this.route("community-media-feedback", { path: "/media/feedback" });
  this.route("community-media", { path: "/media" });
}
